import { Component, ViewChild } from "@angular/core";
import {
  Platform,
  Nav,
  ToastController,
  LoadingController,
  Events
} from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { LoginPage } from "../pages/login/login";
import { HomePage } from "./../pages/home/home";
import { ContratosPage } from "../pages/contratos/contratos";
import { ParticipacaoPage } from "../pages/participacao/participacao";
import { EcoEnelEmpresasPage } from "../pages/ecoenel-empresas/ecoenel-empresas";

import { LoginProvider } from "../providers/login/login.provider";
import { MenuProvider } from "../providers/menu/menu.provider";
import {UserProvider} from "../providers/user/user.provider";
import { PermissionService } from "../providers/permission-service";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  rootPage: any = LoginPage;
  pages: Array<{
    title: string;
    component?: any;
    icon: string;
    isParent?: boolean;
    expanded?: boolean;
    submenus?: Array<{ title: string; component: any; icon: string }>;
  }>;

  showSubmenu: boolean = false;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,

    public toastCtrl: ToastController,
    public _loadingController: LoadingController,

    private loginProvider: LoginProvider,
    private menuProvider: MenuProvider,
    private userProvider: UserProvider,
    private permissionService: PermissionService,
    private events: Events
  ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      var notificationOpenedCallback = function (jsonData) {
        console.log("notificationOpenedCallback: " + JSON.stringify(jsonData));
      };
      document.addEventListener("deviceready", function () {
        window["plugins"].OneSignal.startInit(
          "d8888d33-69e5-40e7-88fe-6e1baff26a43",
          "7299018870"
        )
          .handleNotificationOpened(notificationOpenedCallback)
          .endInit();
      });

      this.checkIsAlreadyLoggedIn();
    });

    // Menu será carregado após login bem-sucedido
    this.events.subscribe('user:loggedIn', (user) => {
      console.log('Evento user:loggedIn recebido, carregando menu...', user);

      this.permissionService.setUser(user);

      this.loadDynamicMenu();
    });
  }

  /**
   * Carrega menu dinâmico do backend baseado no perfil do usuário
   * Chamado após login bem-sucedido
   * Suporta menus hierárquicos (pai > filhos)
   */
  public loadDynamicMenu() {
    this.menuProvider.getMenus().then(response => {
      if (response && response.data) {
        this.pages = response.data.map(menu => {
          if (menu.isParent && menu.submenus) {
            return {
              title: menu.title,
              icon: menu.icon,
              isParent: true,
              expanded: false,
              submenus: menu.submenus.map(sub => ({
                title: sub.title,
                component: this.getComponentClass(sub.component),
                icon: sub.icon,
                controller: sub.controller,
                action: sub.action,
                parameters: sub.parameters
              }))
            };
          } else {
            return {
              title: menu.title,
              component: this.getComponentClass(menu.component),
              icon: menu.icon,
              controller: menu.controller,
              action: menu.action,
              parameters: menu.parameters,
              isParent: false
            };
          }
        });
      } else {
        this.pages = [];
        this.showMenuError();
      }
    }).catch(error => {
      console.error('Erro ao carregar menus:', error);
      this.pages = [];
      this.showMenuError();
    });
  }

  /**
   * Alterna expansão de menu pai
   */
  toggleSubmenu(pagina: any) {
    if (pagina.isParent) {
      pagina.expanded = !pagina.expanded;
    }
  }

  private showMenuError() {
    var toast = this.toastCtrl.create({
      message: 'Erro ao carregar menus. Verifique sua conexão e tente novamente.',
      duration: 4000,
      position: 'bottom'
    });
    toast.present();
  }

  /**
   * Mapeia string do componente para classe real
   */
  private getComponentClass(componentName: string): any {
    const components = {
      'HomePage': HomePage,
      'ContratosPage': ContratosPage,
      'ParticipacaoPage': ParticipacaoPage,
      'EcoEnelEmpresasPage': EcoEnelEmpresasPage,
      'page-ecoenel-empresas': EcoEnelEmpresasPage
    };

    return components[componentName] || HomePage;
  }

  private checkIsAlreadyLoggedIn() {
    if (!this.loginProvider.hasAccessToken()) return;

    this.userProvider.getUserAuth()
      .toPromise()
      .then((user) => {
        // Configurar permissões do usuário - Ticket #5954
        this.permissionService.setUser(user);
        console.log('PermissionService configurado para:', user.perfil && user.perfil.nome ? user.perfil.nome : 'sem perfil');

        this.events.publish('user:loggedIn', user);

        // Redirecionar baseado no perfil
        var perfilNome = (user && user.perfil && user.perfil.nome) ? user.perfil.nome : '';
        var perfisEcoEnel = ['GRANDE GERADOR', 'RECICLADOR'];

        if (perfisEcoEnel.indexOf(perfilNome) !== -1) {
          this.nav.setRoot(EcoEnelEmpresasPage);
        } else {
          this.nav.setRoot(HomePage);
        }
      })
      .catch(() => {
        console.log('Usuário não está logado, aguardando login...')
      })
  }

  navegarPara(page) {
    this.nav.push(page, {});
  }

  logout() {
    let loading = this._loadingController.create({ content: "Saindo..." });

    this.loginProvider
      .logout()
      .then((success) => {
        loading.dismiss();
        this.reload("Ambiente encerrado!");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  private reload(mensagem: string) {
    let toast = this.toastCtrl.create({ duration: 1500 });
    let self = this;

    toast.setMessage(mensagem);
    toast.present();
    toast.onDidDismiss(() => {
      self.nav.setRoot(LoginPage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts